import { ReactNode } from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import { usePageEnabled } from "@/hooks/useCMSPages";

/**
 * Hides a public page when it is switched off in the CMS.
 * Admins can preview a disabled page with ?site=1.
 */
export function PageGate({ pageKey, children }: { pageKey: string; children: ReactNode }) {
  const [searchParams] = useSearchParams();
  const bypass = searchParams.get("site") === "1";
  const { isEnabled, isLoading } = usePageEnabled(pageKey);

  if (bypass) return <>{children}</>;

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!isEnabled) return <Navigate to="/" replace />;

  return <>{children}</>;
}

export default PageGate;
